import { lazy } from 'react';
import {
  Tent, ClipboardList, Users, Calendar, BarChart3, Bed, LayoutList, ClipboardCheck, Car, Calculator, Banknote,
} from 'lucide-react';
import { defineFrontendModule } from '../../core/modules/types';
import { EventProvider } from './contexts/EventContext';
import { EventSelector } from './components/EventSelector';
import { registerRetreatWidgets } from './widgets';
import { recallProgram } from './utils/programMemory';

// Placeholders kept from 1.x so the URLs stay valid
function PaymentsPage() {
  return <div>Payments Page</div>;
}
function ReportsPage() {
  return <div>Reports Page</div>;
}

export default defineFrontendModule({
  id: 'retreat',
  name: 'Freizeiten',

  routes: [
    { path: 'retreat/registrations', menuKey: 'retreat.registrations', element: lazy(() => import('./pages/Registrations')) },
    { path: 'retreat/checkin', menuKey: 'retreat.checkin', element: lazy(() => import('./pages/CheckIn')) },
    { path: 'retreat/events', menuKey: 'retreat.events', element: lazy(() => import('./pages/Events')) },
    { path: 'retreat/participants', menuKey: 'retreat.participants', element: lazy(() => import('./pages/Participants')) },
    { path: 'retreat/rooms', menuKey: 'retreat.rooms', element: lazy(() => import('./pages/Rooms')) },
    { path: 'retreat/prices', menuKey: 'retreat.prices', element: lazy(() => import('./pages/Prices')) },
    { path: 'retreat/payments', menuKey: 'retreat.payments', element: PaymentsPage },
    { path: 'retreat/planning', menuKey: 'retreat.planning', element: lazy(() => import('./pages/Planning')) },
    { path: 'retreat/carpool', menuKey: 'retreat.carpool', element: lazy(() => import('./pages/CarpoolPlanning')) },
    { path: 'retreat/billing/:eventId', menuKey: 'retreat.billing', element: lazy(() => import('./pages/Billing')) },
    { path: 'retreat/billing', menuKey: 'retreat.billing', element: lazy(() => import('./pages/Billing')) },
    { path: 'retreat/reports', menuKey: 'retreat.reports', element: ReportsPage },
    { path: 'retreat/subevents/:id', menuKey: 'retreat.planning', element: lazy(() => import('./pages/SubEvents')) },
    { path: 'retreat/program-stats', menuKey: 'retreat.program-stats', element: lazy(() => import('./pages/ProgramStats')) },
    { path: 'retreat/sub-events', menuKey: 'retreat.planning', element: lazy(() => import('./pages/SubEvents')) },
  ],

  publicRoutes: [{ path: '/programm/:eventId', element: lazy(() => import('./pages/PublicProgram')) }],

  // Visitors who opened a public program before land on it again.
  publicLanding: () => {
    const lastProgramId = recallProgram();
    return lastProgramId ? `/programm/${lastProgramId}` : null;
  },

  providers: [EventProvider],

  nav: [
    {
      menuKey: 'retreat',
      defaultIcon: Tent,
      header: EventSelector,
      items: [
        { menuKey: 'retreat.registrations', path: '/retreat/registrations', label: 'Anmeldungen', icon: ClipboardList },
        { menuKey: 'retreat.planning', path: '/retreat/participants', label: 'Teilnehmer', icon: Users },
        { menuKey: 'retreat.events', path: '/retreat/subevents/1', label: 'Programm', icon: Calendar },
        { menuKey: 'retreat.program-stats', path: '/retreat/program-stats', label: 'Programmstatistik', icon: BarChart3 },
        { menuKey: 'retreat.rooms', path: '/retreat/rooms', label: 'Gebäudeplanung', icon: Bed, section: 'Unterkunft' },
        { menuKey: 'retreat.planning', path: '/retreat/planning', label: 'Belegungsplanung', icon: LayoutList },
        { menuKey: 'retreat.checkin', path: '/retreat/checkin', label: 'An- & Abreise', icon: ClipboardCheck, section: 'Vor Ort' },
        { menuKey: 'retreat.carpool', path: '/retreat/carpool', label: 'Mitfahr-Planung', icon: Car },
        { menuKey: 'retreat.billing', path: '/retreat/billing', label: 'Abrechnung', icon: Calculator },
        { menuKey: 'retreat.prices', path: '/retreat/prices', label: 'Preise', icon: Banknote, section: 'Einstellungen' },
        { menuKey: 'retreat.events', path: '/retreat/events', label: 'Veranstaltungen', icon: Calendar },
      ],
    },
  ],

  registerWidgets: registerRetreatWidgets,
});
